import { InputAdornment } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';
import { getCurrencySymbol } from '@vy/services';
import { DEFAULT_CURRENCY, type UsageProductInput } from '@vy/types';
import { type ValueOf } from '@vy/utils';
import { type FieldPath } from 'react-hook-form';
import { ModifyButton } from '../../ModifyButton';
import { MeteredCreditEditCell } from '../metered-credits-charges-edit-table-components/MeteredCreditEditCell';
import { MeteredCreditProductSourceSelect } from '../metered-credits-charges-edit-table-components/MeteredCreditProductSourceSelect';
import { RemoveMeteredCreditRow } from '../metered-credits-charges-edit-table-components/RemoveMeteredCreditRow';

export const METERED_CREDITS_CHARGES_EDIT_COLUMNS_KEYS = {
  TYPE: 'pricingModel',
  NAME: 'name',
  PRODUCT_SOURCE: 'productSource',
  AMOUNT: 'customAmount',
  OTHER: 'other',
  DELETE_ROW: 'deleteRow',
} as const;

export type MeteredCreditsChargesEditColumnsKey = ValueOf<typeof METERED_CREDITS_CHARGES_EDIT_COLUMNS_KEYS>;

export const METERED_CREDITS_CHARGES_EDIT_COLUMNS: GridColDef<UsageProductInput>[] = [
  {
    field: METERED_CREDITS_CHARGES_EDIT_COLUMNS_KEYS.TYPE,
    headerName: 'Type',
    sortable: false,
    minWidth: 180,
    renderCell: () => 'Metered Credit',
  },
  {
    field: METERED_CREDITS_CHARGES_EDIT_COLUMNS_KEYS.NAME,
    headerName: 'Name',
    flex: 1,
    sortable: false,
    renderCell: ({ row, field }) => (
      <MeteredCreditEditCell
        meteredCredit={row}
        field={field as FieldPath<UsageProductInput>}
        placeholder="Credit name"
        fullWidth
      />
    ),
  },
  {
    field: METERED_CREDITS_CHARGES_EDIT_COLUMNS_KEYS.PRODUCT_SOURCE,
    headerName: 'Product Source',
    flex: 2,
    sortable: false,
    renderCell: ({ row }) => {
      return <MeteredCreditProductSourceSelect meteredCredit={row} />;
    },
  },
  {
    field: METERED_CREDITS_CHARGES_EDIT_COLUMNS_KEYS.AMOUNT,
    headerName: 'Amount',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) => {
      const prefix = getCurrencySymbol(DEFAULT_CURRENCY);

      return (
        <MeteredCreditEditCell
          meteredCredit={row}
          field={'variants.0.pricing.priceConfiguration.price'}
          valueAsNumber
          type="number"
          placeholder="0"
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start" className="text-gray-400">
                  {prefix}
                </InputAdornment>
              ),
            },
          }}
        />
      );
    },
  },
  {
    field: METERED_CREDITS_CHARGES_EDIT_COLUMNS_KEYS.OTHER,
    headerName: 'Add on',
    headerClassName: 'pr-4',
    headerAlign: 'right',
    cellClassName: 'justify-end items-center',
    renderCell: () => <ModifyButton />,
    sortable: false,
    flex: 2,
  },
  {
    field: METERED_CREDITS_CHARGES_EDIT_COLUMNS_KEYS.DELETE_ROW,
    headerName: '',
    sortable: false,
    width: 30,
    renderCell: ({ row }) => <RemoveMeteredCreditRow meteredCredit={row} />,
  },
];
